<div class="checkout-page">

  <div class="checkout-container">

    <div class="checkout-card">

      <h1>
        Quase lá!
      </h1>

      <p class="subtitle">
        Informe os dados dos hóspedes
      </p>

      <div
        class="hospede-bloco"
        *ngFor="let hospede of hospedes; let i = index"
      >

        <div class="hospede-title">

          Hóspede {{ i + 1 }}

          <span *ngIf="i === 0">
            (responsável pela reserva)
          </span>

        </div>


        <div class="form-grid">

          <input
            type="text"
            placeholder="Nome"
            [(ngModel)]="hospede.nome"
            maxlength="50"
            autocomplete="given-name"
            oninput="this.value = this.value.replace(/[0-9]/g, '')"
          />

          <input
            type="text"
            placeholder="Último Nome"
            [(ngModel)]="hospede.sobrenome"
            maxlength="50"
            autocomplete="family-name"
            oninput="this.value = this.value.replace(/[0-9]/g, '')"
          />

          <!-- Somente Hóspede 1 -->
          <input
            *ngIf="i === 0"
            type="email"
            placeholder="E-mail"
            [(ngModel)]="hospede.email"
            maxlength="100"
            autocomplete="email"
          />

          <input
            type="text"
            placeholder="Telefone"
            [ngModel]="formatarTelefone(hospede.telefone)"
            (ngModelChange)="hospede.telefone = somenteNumeros($event, 11)"
            maxlength="15"
            inputmode="numeric"
            autocomplete="tel"
          />

          <!-- Somente Hóspede 1 -->
          <input
            *ngIf="i === 0"
            type="text"
            placeholder="CPF"
            [ngModel]="formatarCpf(hospede.cpf)"
            (ngModelChange)="hospede.cpf = somenteNumeros($event, 11)"
            maxlength="14"
            inputmode="numeric"
            autocomplete="off"
          />

        </div>

      </div>

      <div class="actions">

        <button
          type="button"
          (click)="continuar()"
        >
          Continuar
        </button>

      </div>

    </div>

    <div class="resumo-card">

      <img
        [src]="dados?.quartoImagem || '/cabana-ype.PNG'"
        [alt]="dados?.quartoNome || 'Acomodação'"
      />

      <h3>
        {{ dados?.quartoNome || 'Acomodação' }}
      </h3>

      <p>
        {{ descricaoAcomodacao }}
      </p>

      <div class="resumo-linha">

        <strong>
          Check-in
        </strong>

        <span>
          {{ formatarData(dados?.checkIn) }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Check-out
        </strong>

        <span>
          {{ formatarData(dados?.checkOut) }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>

          {{ quantidadeAdultos }}

          {{
            quantidadeAdultos === 1
              ? 'adulto'
              : 'adultos'
          }}


          <ng-container
            *ngIf="quantidadeCriancas > 0"
          >

            • {{ quantidadeCriancas }}

            {{
              quantidadeCriancas === 1
                ? 'criança'
                : 'crianças'
            }}

          </ng-container>

        </span>

      </div>

      <div
        class="resumo-linha"
        *ngIf="quantidadeAnimais > 0"
      >

        <strong>
          Animais
        </strong>

        <span>

          {{ quantidadeAnimais }}

          {{
            quantidadeAnimais === 1
              ? 'animal'
              : 'animais'
          }}

        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Noites
        </strong>

        <span>
          {{ quantidadeNoites }}
        </span>

      </div>

      <div class="resumo-linha total">

        <strong>
          Preço total
        </strong>

        <span>
          R$ {{ valorTotal | number:'1.2-2' }}
        </span>

      </div>

    </div>

  </div>

</div>
